import { bl_b2b_process_tracking_ipo_xdo_igrn_hdr_RowClass, bl_b2b_process_tracking_einvoice_hdr_RowClass } from '../../../../../models/dbschema';

export class EinvoiceB2BSummaryDto {
    hdr: bl_b2b_process_tracking_einvoice_hdr_RowClass;
    lines: bl_b2b_process_tracking_ipo_xdo_igrn_hdr_RowClass[];
  }